<template>
  <v-btn class="back-button" :to="to" :color="color">{{ text }}</v-btn>
</template>

<script>
  export default {
    name: 'BackButton',
    props: {
      to: [ String ],
      color: String,
      text: String
    }
  };
</script>

<style scoped>
  .back-button {
    position: fixed;
    margin-left: auto;
    bottom: 64px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BackButton/BackButton.vue